/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 公司排名搜索
 */

import commonStyles  from '../../common/common.scss';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Select, Form } from 'antd';
import {getChildOptions} from '../../../../../utils/util';
const FormItem = Form.Item;
const Option = Select.Option;

class SearchForm extends PureComponent {
    static defaultProps = {
        showSubType: false
    };

    constructor(props) {
        super(props);
        this.state = {
            options: {},
            subAnaTypeOptions: []
        };
    }

    componentDidMount() {
        this.setOptions();
    }

    componentWillReceiveProps(nextProps) {
        this.setOptions(nextProps);
    }

    setOptions = (props = this.props) => {
        const { options, onFail } = props;
        if (!this.initialized && (options || options === false)) {
            this.initialized = true;
            if (options) {
                this.setState({
                    options,
                    subAnaTypeOptions: options.riskFakeTypes[0] && options.riskFakeTypes[0].childs || []
                }, () => {
                    this.onSubmit();
                });
            } else { // option请求失败
                onFail && onFail();
            }
        }
    };

    resetSubFields = (v) => {
        const { options } = this.state;
        this.setState({
            subAnaTypeOptions: getChildOptions(v, options.riskFakeTypes)
        }, () => {
            this.props.form.resetFields(['subStatisticType']);
        });
    };

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values);
            }
        });
    };

    render() {
        const { showSubType, form } = this.props;
        const { getFieldDecorator } = form;
        const { options, subAnaTypeOptions } = this.state;
        const { reportYear = [], reportType = [], reportDateType = [], riskFakeTypes = [] } = options;
        return (
            <div className={classNames('search-bar', commonStyles.searchBar)}>
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <FormItem>
                        {getFieldDecorator('reportYear', {
                            initialValue: reportYear[0]
                        })(
                            <Select placeholder="年份" size="default">
                                { reportYear.map(d => <Option key={d} value={d}>{d}</Option>) }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('reportDateType', {
                            initialValue: reportDateType[0] && reportDateType[0].key
                        })(
                            <Select placeholder="时间类型" size="default">
                                { reportDateType.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem className="hide">
                        {getFieldDecorator('reportType', {
                            initialValue: reportType[0] && reportType[0].key
                        })(
                            <Select placeholder="报表类型" size="default">
                                { reportType.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('statisticType', {
                            initialValue: riskFakeTypes[0] && riskFakeTypes[0].key
                        })(
                            <Select placeholder="风险类型" size="default" onChange={this.resetSubFields}>
                                { riskFakeTypes.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                            </Select>
                        )}
                    </FormItem>
                    {
                        showSubType ?
                            <FormItem>
                                {getFieldDecorator('subStatisticType', {
                                    initialValue: subAnaTypeOptions[0] && subAnaTypeOptions[0].key
                                })(
                                    <Select placeholder="评分项" size="default">
                                        { subAnaTypeOptions.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                    </Select>
                                )}
                            </FormItem> : null
                    }
                    <button type="submit" className="btn btn-blue">搜索</button>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/financialOverview/common/SearchForm.jsx